import React from "react";
import { useHistory } from "react-router-dom";

// Cabeçalho da página inicial nova (reforma 2026), usado também na /tv.
// As âncoras (#telas, #planos, #faq) existem nas duas páginas.
// Fora da página inicial, o logo leva de volta a ela (logoParaInicio).
export default function Cabecalho({ logoParaInicio = false }) {
  const history = useHistory();
  const logo = <img className="nav-logo" src="/icons/logo.svg" alt="JoinKids" />;

  return (
    <header className="nav">
      <div className="wrap nav-inner">
        {logoParaInicio ? <a href="/" aria-label="Página inicial da JoinKids" style={{ display: "flex" }}>{logo}</a> : logo}
        <nav className="nav-links">
          <a className="navlink" href="#telas">Onde assistir</a>
          <a className="navlink" href="/conteudos">Conteúdos</a>
          <a className="navlink" href="#planos">Planos</a>
          <a className="navlink" href="#faq">Dúvidas</a>
          <div className="nav-cta">
            <button className="btn btn-ghost" onClick={() => history.push("/login")}>Entrar</button>
            <a className="btn btn-green" style={{ fontSize: 15, padding: "10px 22px" }} href="#planos">Assinar</a>
          </div>
        </nav>
      </div>
    </header>
  );
}
